import { render, staticRenderFns } from "./glob.vue?vue&type=template&id=90fc4810&scoped=true&"
import script from "./glob.vue?vue&type=script&lang=js&"
export * from "./glob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc4810",
  null
  
)

export default component.exports